import { AxiosError, AxiosResponse, AxiosStatic } from "axios"

export default (http: AxiosStatic, resource = '/api/students') => ({
    getStudyName(language: string, programId: number,): Promise<AxiosResponse> {
        return new Promise<AxiosResponse>((resolve, reject) => {
            http
                .get(`${resource}/${language}/studies/${programId}`)
                .then((response: AxiosResponse) => {
                    resolve(response)
                })
                .catch((error: AxiosError) => {
                    reject(error.response)
                })
        })
    }
})
